import React from "react";
import {predictModels} from "../../../utils/DataModals";

function DeactiveModelModal({modalName, onclose, modelIsOpen,  oncloseFirstModal}){

    if(!modelIsOpen){
        return null;
    }

    const DeactiveModel=()=>{
        predictModels.filter((model) => {
            if(model.Name === modalName){
                model.Status = "Inactive"
            }                 
        })
        onclose();
        oncloseFirstModal();
    }

    return(

        <div className="fixed z-50 flex justify-center items-center inset-0 bg-pale-white opacity-4">
            <div className="pt-3 rounded-md shadow-2xl h-[200px] w-[400px]">
                <div>
                    <h1 className="text-lg font-semibold px-4">Deactivate {modalName}</h1>
                    <p className="mt-2 text-justify px-4">Are you sure you want to deactivate "{modalName}"? By deactivating "{modalName}", you won't be able to use the prediction model.</p>
                </div>
                <div className="mt-3 bg-neutral flex justify-end pb-2 pr-3">
                    <button className="mt-2 mr-4 px-2 py-0.5 rounded-md bg-white" onClick={onclose}>Cancel</button>
                    <button className="mt-2 bg-warning px-2 py-0.5 rounded-md text-white" onClick={DeactiveModel}>Deactive</button>
                </div>
            </div>
        </div>
       
    )
}

export default DeactiveModelModal;